import { render, staticRenderFns } from "./ProuniStepLayout.vue?vue&type=template&id=ad86adda&scoped=true&"
import script from "./ProuniStepLayout.vue?vue&type=script&lang=ts&"
export * from "./ProuniStepLayout.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniStepLayout.vue?vue&type=style&index=0&id=ad86adda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad86adda",
  null
  
)

export default component.exports